import { apiConnector } from './apiconnector';

const SUPER_ADMIN_API_BASE = `${process.env.REACT_APP_API_URL}/super-admin`;


export const superAdminAPI = {
  // Dashboard analytics with comprehensive data
  getDashboardAnalytics: async (period = 'month') => {
    try {
      const response = await apiConnector('GET', `${SUPER_ADMIN_API_BASE}/dashboard?period=${period}`);
      return response.data;
    } catch (error) {
      console.error('Get dashboard analytics error:', error);
      throw error;
    }
  },

  // System statistics
  getSystemStats: async () => {
    try {
      const response = await apiConnector('GET', `${SUPER_ADMIN_API_BASE}/stats`);
      return response.data;
    } catch (error) {
      console.error('Get system stats error:', error);
      throw error;
    }
  },

  // User management with advanced filtering
  getAllUsers: async (params ) => {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });
      
      const response = await apiConnector('GET', `${SUPER_ADMIN_API_BASE}/users?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Get all users error:', error);
      throw error;
    }
  },

  // Create admin user
  createAdminUser: async (userData) => {
    try {
      const response = await apiConnector('POST', `${SUPER_ADMIN_API_BASE}/users/admin`, userData);
      return response.data;
    } catch (error) {
      console.error('Create admin user error:', error);
      throw error;
    }
  },

  // Update user
  updateUser: async (userId, userData) => {
    try {
      const response = await apiConnector('PUT', `${SUPER_ADMIN_API_BASE}/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  },

  // Delete user
  deleteUser: async (userId) => {
    try {
      const response = await apiConnector('DELETE', `${SUPER_ADMIN_API_BASE}/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Delete user error:', error);
      throw error;
    }
  },

  // Get plant analytics
  getPlantAnalytics: async (plantId, period = 'month') => {
    try {
      const endpoint = plantId 
        ? `${SUPER_ADMIN_API_BASE}/plants/analytics/${plantId}?period=${period}`
        : `${SUPER_ADMIN_API_BASE}/plants/analytics?period=${period}`;
      
      const response = await apiConnector('GET', endpoint);
      return response.data;
    } catch (error) {
      console.error('Get plant analytics error:', error);
      throw error;
    }
  }
};